import { toLocalUSString } from '../../../../../../../shared/utils';

export const getTotalCountViewValue = (count) => {
    if (count <= 10000) return toLocalUSString(count);
    return 'over 10,000';
};
